<!--
 * @Description: 平安校园-应急预案 详情
 * @Author: PF
 * @Date: 2024-02-22 14:40:34.376
 * @LastEditors: PF
 * @LastEditTime: 2024-02-23 09:24:12
-->
<template>
  <div>
    <el-dialog class="wp80 hp85" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="应急预案标题" label-align="right" align="left" width="150px" span="2">{{ruleForm.yjyabt}}</el-descriptions-item>
        <el-descriptions-item label="应急预案类别" label-align="right" align="left" width="150px" span="2">{{ruleForm.yjyalbmc}}</el-descriptions-item>
        <el-descriptions-item label="应急预案发布日期" label-align="right" align="left" span="2">{{ruleForm.yjyafbsj}}</el-descriptions-item>
        <el-descriptions-item label="应急预案签发人" label-align="right" align="left" span="2">{{ruleForm.yjyaqfrmc}}</el-descriptions-item>
        <el-descriptions-item label="应急预案发布范围" label-align="right" align="left" span="4">{{ruleForm.yjyafbfwmc}}</el-descriptions-item>
        <el-descriptions-item label="应急预案内容" label-align="right" align="left" span="4">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.yjyanr"></p>
        </el-descriptions-item>
      </el-descriptions>
        <el-divider>职责分工</el-divider>
          <el-table :data="ruleForm.listTiaoLi" style="width: 100%" border>
            <el-table-column fixed type="index" label="序号" align="center" width="80" />
            <el-table-column prop="yjyatlbt" label="职责" align="center" min-width="100" show-overflow-tooltip />
            <el-table-column prop="" label="责任人" align="center" min-width="100" show-overflow-tooltip>
              <template #default="scope">
                <span v-for="(item, index) in scope.row.yjyatlzrrid" :key="index" style="margin-bottom:5px">
                  <span v-if="index !== 0">，</span>
                  <span v-if="item.zrrlx===1">{{item.zwmc}}</span>
                  <span v-if="item.zrrlx===2">{{item.zrrmc}}</span>
                </span>
              </template>
            </el-table-column>
          </el-table>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      let url = ''
      if (props.row.zt) {
        url = '/api/v2/pinganxiaoyuan/pinganxiaoyuanyingjiyuan/' + props.row.id + '/' + props.row.zt
      } else {
        url = '/api/v2/pinganxiaoyuan/pinganxiaoyuanyingjiyuan/' + props.row.id + '/2'
      }
      loadData({ url: url, ruleForm })
    }
  },
  { deep: true, immediate: true }
)
</script>
